import { put, call, takeEvery } from "redux-saga/effects";

import * as apis from "../../network/apis/applicatsTimeSheets";
import * as types from "./types";
import * as actions from "./actions";

import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";
import { getDailyAndMonthlyReportsRequests } from "../TimeSheet/actions";

const buildSlotsRefetchParams = (payload) => {
  if (payload.refetchParams) {
    return payload.refetchParams;
  }

  const params = {
    page: 1,
    items: 10,
    event_id: payload.data?.event_id ?? payload.event_id ?? payload.eventId,
    user_id: payload.data?.user_id ?? payload.user_id ?? payload.userId,
  };

  if (!payload.isDaily) {
    params.check_in_month_in_a_date = payload.dateParam;
  }

  return params;
};

function* getApplicantsTimeSheetRequestsListSaga({ payload }) {
  try {
    const response = yield call(
      apis.getApplicantsTimeSheetRequestsList,
      payload
    );

    yield put(
      actions.getApplicantstTimeSheetResponse({
        list: response?.data?.data,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"],
        },
      })
    );
    if (+response.headers["current-page"] > +response.headers["total-pages"]) {
      yield put(
        actions.getApplicantstTimeSheetRequests({
          ...payload,
          page: +response.headers["total-pages"],
        })
      );
    }
  } catch (error) {
    yield error.response && showErrorMsg(error.response?.data?.message);
  }
}
function* addApplicantTimeSheetSaga({ payload }) {
  const { onSuccess, onError, ...requestPayload } = payload;

  try {
    yield call(apis.addApplicantTimeSheet, requestPayload);
    yield call(showSuccessMsg, "addedSuccessfully");
    yield put(
      actions.getApplicantstTimeSheetRequests(buildSlotsRefetchParams(requestPayload)),
    );
    if (requestPayload.refetchWorkingLogs) {
      yield put(getDailyAndMonthlyReportsRequests(requestPayload.refetchWorkingLogs));
    }
    if (typeof onSuccess === "function") {
      onSuccess();
    }
  } catch (error) {
    if (typeof onError === "function") {
      onError(error);
    }
    if (error?.response) {
      yield call(showErrorMsg, error.response?.data?.message);
    }
  }
}

function* editApplicantTimeSheetSaga({ payload }) {
  const { onSuccess, onError, ...requestPayload } = payload;

  try {
    yield call(apis.editApplicantsTimeSheet, requestPayload);
    yield call(showSuccessMsg, "updatedSuccessfully");
    yield put(
      actions.getApplicantstTimeSheetRequests(buildSlotsRefetchParams(requestPayload)),
    );
    if (requestPayload.refetchWorkingLogs) {
      yield put(getDailyAndMonthlyReportsRequests(requestPayload.refetchWorkingLogs));
    }
    if (typeof onSuccess === "function") {
      onSuccess();
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    if (err?.response) {
      yield call(showErrorMsg, err.response?.data?.message);
    }
  }
}

function* deleteApplicantsTimeSheetSaga({ payload }) {
  try {
    yield call(apis.deleteApplicantTimeSheet, payload);
    yield showSuccessMsg("deletedSuccessfully");
    yield put(actions.getApplicantstTimeSheetRequests(buildSlotsRefetchParams(payload)));
    if (payload.refetchWorkingLogs) {
      yield put(getDailyAndMonthlyReportsRequests(payload.refetchWorkingLogs));
    }
  } catch (err) {
    yield showErrorMsg(err.response?.data?.message);
  }
}

export default function* ApplicantsTimeSheetRequestsListSaga() {
  yield takeEvery(
    types.GET_APPLICANTS_WORKING_SLOTS_REQUEST,
    getApplicantsTimeSheetRequestsListSaga
  );
  yield takeEvery(types.ADD_APPLICANT_TIME_SHEET, addApplicantTimeSheetSaga);
  yield takeEvery(
    types.EDIT_APPLICANT_SHEET_REQUEST,
    editApplicantTimeSheetSaga
  );
  yield takeEvery(
    types.DELETE_APPLICANT_SHEET_REQUEST,
    deleteApplicantsTimeSheetSaga
  );
}
